import React from 'react';
import { Mail, Linkedin, Twitter, Instagram } from 'lucide-react';
export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer id="contact" className="bg-gray-900 text-white py-16 px-4" data-id="element-25">
      <div className="max-w-7xl mx-auto" data-id="element-26">
        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-27">
          {/* Logo & Description */}
          <div className="md:col-span-2" data-id="element-28">
            <div className="flex items-center gap-2 mb-4" data-id="element-29">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-30">
                <circle cx="20" cy="20" r="18" fill="#4ADE80" data-id="element-31" />
                <ellipse cx="15" cy="18" rx="2" ry="3" fill="#1F2937" data-id="element-32" />
                <ellipse cx="25" cy="18" rx="2" ry="3" fill="#1F2937" data-id="element-33" />
                <path d="M 12 25 Q 20 28 28 25" stroke="#1F2937" strokeWidth="2" strokeLinecap="round" fill="none" data-id="element-34" />
                <path d="M 8 12 L 12 8 L 14 12 Z" fill="#8B5CF6" data-id="element-35" />
                <path d="M 32 12 L 28 8 L 26 12 Z" fill="#8B5CF6" data-id="element-36" />
              </svg>
              <span className="text-2xl font-bold" data-id="element-37">Goblincamp</span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md" data-id="element-38">
              Transforming educational marketing and school outreach with
              creativity, strategy, and a touch of magic.
            </p>
            <div className="space-y-2 text-gray-400" data-id="element-39">
              <p data-id="element-40">Limassol, Cyprus</p>
              <a href="mailto:hello@goblincamp.com" className="flex items-center gap-2 hover:text-purple-400 transition-colors" data-id="element-41">
                <Mail size={18} data-id="element-42" />
                hello@goblincamp.com
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-43">
            <h3 className="font-bold text-lg mb-4" data-id="element-44">Quick Links</h3>
            <ul className="space-y-2" data-id="element-45">
              <li data-id="element-46">
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-47">
                  About
                </button>
              </li>
              <li data-id="element-48">
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-49">
                  Services
                </button>
              </li>
              <li data-id="element-50">
                <button onClick={() => scrollToSection('how-it-works')} className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-51">
                  How It Works
                </button>
              </li>
              <li data-id="element-52">
                <button onClick={() => scrollToSection('pricing')} className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-53">
                  Pricing
                </button>
              </li>
              <li data-id="element-54">
                <button onClick={() => scrollToSection('team')} className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-55">
                  Team
                </button>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div data-id="element-56">
            <h3 className="font-bold text-lg mb-4" data-id="element-57">Connect With Us</h3>
            <div className="flex gap-4" data-id="element-58">
              <a href="#" className="bg-gray-800 p-3 rounded-full hover:bg-purple-600 transition-colors" data-id="element-59">
                <Linkedin size={20} data-id="element-60" />
              </a>
              <a href="#" className="bg-gray-800 p-3 rounded-full hover:bg-purple-600 transition-colors" data-id="element-61">
                <Twitter size={20} data-id="element-62" />
              </a>
              <a href="#" className="bg-gray-800 p-3 rounded-full hover:bg-purple-600 transition-colors" data-id="element-63">
                <Instagram size={20} data-id="element-64" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-8 text-center text-gray-400" data-id="element-65">
          <p data-id="element-66">© 2026 Goblincamp. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}